import React, { useState } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { TodoModel } from "../models";
import { Checkbox, Row, Col } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { useStores } from "../store";
import { DeleteOutlined } from "@ant-design/icons";
import DOMPurify from "dompurify";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
/**
 * Removable todo item.
 */
const TodoItem = observer(({ todo }: { todo: TodoModel }) => {
    const { todoStore } = useStores();
    const [isHover, setHover] = useState(false);

    const handleCheckBox = (e: CheckboxChangeEvent) => {
        todoStore.updateTodo(todo, e.target.checked);
    };

    const handleClassName = (): string => {
        return classNames(todo.status.isDone && "checked-todo");
    };

    const handleDelete = () => {
        todoStore.deleteTodo(todo);
    };

    return (
        <li key={todo.id} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <Row className={isHover && "todo-active"} wrap={false}>
                <Col className="gutter-row" flex="auto">
                    <label className={handleClassName()}>
                        <Checkbox onChange={handleCheckBox} checked={todo.status.isDone}>
                            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(todo.description) }}></span>
                        </Checkbox>
                    </label>
                </Col>
                <Col className="gutter-row" flex="none">
                    {isHover && (
                        <span className="todo-actions" onClick={handleDelete}>
                            <DeleteOutlined />
                        </span>
                    )}
                </Col>
            </Row>
        </li>
    );
});

export { TodoItem };
